export default (property, componentToRender) => (property !== null ? componentToRender : null);
